import { createContext } from 'react'

export type OrgRole = 'owner' | 'admin' | 'accountant' | 'viewer'

export interface Organization {
  id: string
  name: string
  role: OrgRole
  bookStartDate: string | null
  currencyCode: string
}

export interface OrganizationContextValue {
  organization: Organization | null
  organizations: Organization[]
  switchOrganization: (id: string) => void
  loading: boolean
  error: string | null
  /** True when the signed-in user belongs to no organization yet. */
  needsOnboarding: boolean
}

/** Remembers the last-used org across sessions. */
export const ORG_STORAGE_KEY = 'cbs.organization'

export const OrganizationContext = createContext<OrganizationContextValue | null>(null)

const ROLE_RANK: Record<OrgRole, number> = {
  viewer: 0,
  accountant: 1,
  admin: 2,
  owner: 3,
}

/**
 * Role check for hiding UI a user cannot use.
 *
 * This is a convenience for the interface only. The database enforces the same
 * rules in RLS, and that is the check that actually matters — a hostile client
 * can call PostgREST directly and never run this code.
 */
export function hasRole(role: OrgRole | undefined, minimum: OrgRole): boolean {
  if (!role) return false
  return ROLE_RANK[role] >= ROLE_RANK[minimum]
}
